import { FormGroup } from '@angular/forms';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getCoopPescaGroup = (form: FormGroup): FormGroup => getGroup(form, formPaths.schedaCoopPesca);

export const getCoopPescaControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.schedaCoopPesca}.${path}`);
